import React from 'react';
import { stores } from '../constant/data';

const RetailAvailability = () => {


    return (
        
        <div className="w-full bg-[#F4F5F7] py-12">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row items-center justify-center gap-8">
                    <div className="flex flex-wrap items-center justify-center gap-4">
                        {stores.map((store, index) => (
                            <div key={index} className="relative w-[110px] h-[30px]">
                                <img
                                    src={store.logo}
                                    alt={`Not available at ${store.name}`}
                                    className="w-full h-full object-contain"
                                />
                            </div>
                        ))}
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="relative w-[20px] h-[20px]">
                            <img
                                src="https://sinoclear.net/pm/images/check-mark.svg"
                                alt="Checkmark"
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <div className="text-[#1B365D] font-bold">
                            Only Available<br />
                            On This Page!
                        </div>
                    </div>
                </div>
                <div className="mt-6 max-w-4xl mx-auto text-start">
                    <p className="text-gray-900 text-base">
                        <span className="font-bold">Lung Renew is not sold in stores or elsewhere online and as a custom proprietary product, it will never be.</span>{" "}
                        It is only available for purchase on this page ONLY. {" "}
                        <span className="font-bold">This is the very last time </span>
                        you'll be able to claim this new customer VIP discount.{" "} Select your package and claim your one-time savings now. Protect your lungs now and well into the future. Do it for yourself, and do it for your family.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RetailAvailability;

